// NPM Imports
import React from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Actions Import
import SharedDocumentActions from "../../../actions/SharedDocumentActions";

// Destructuring
const { recipientDocAcceptRejectAction } = SharedDocumentActions;

// Internals Imports
const RecipientDocHeaderRejectButton = ({
  recipientDocAcceptReject,
  isMobileView,
  className,
}) => {
  const _onReject = () => {
    recipientDocAcceptReject("reject", true);
  };
  const _rejectBtn = () => (
    <span
      className={`recipientdocheader-button inside-dropdown ${className}`}
      data-test="recipientdocheader-download-button"
      onClick={_onReject}
      tabIndex="0"
      onKeyDown={() => {}}
      role="button">
      <FontAwesomeIcon
        icon={["far", "thumbs-down"]}
        className="recipientdocheaderbuttons-icon accept-decline-btn"
      />
      Decline
    </span>
  );

  return isMobileView ? (
    _rejectBtn()
  ) : (
    <Tooltip
      placement="left"
      align={{
        offset: [0, 4],
      }}
      overlay="Reject this document">
      {_rejectBtn()}
    </Tooltip>
  );
};

// const mapStateToProps = state => {
// };

const mapDispatchToProps = {
  recipientDocAcceptReject: recipientDocAcceptRejectAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(RecipientDocHeaderRejectButton);
